import React, { useState, useEffect } from 'react';
import { getCompanyColor } from '../constants/colors';
import { getCompanyDomain, getCompanyInitials } from '../constants/companyLogos';

const SIZE_CLASSES = {
  xs: 'w-5 h-5 text-[9px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
};

function buildLogoSources(domain) {
  if (!domain) return [];
  return [
    `https://www.google.com/s2/favicons?domain=${domain}&sz=128`,
    `https://logo.clearbit.com/${domain}`,
    `https://icons.duckduckgo.com/ip3/${domain}.ico`,
  ];
}

function CompanyLogo({ name, size = 'md', className = '' }) {
  const [sourceIndex, setSourceIndex] = useState(0);
  const domain = getCompanyDomain(name);
  const color = getCompanyColor(name);
  const initials = getCompanyInitials(name);
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const sources = buildLogoSources(domain);

  useEffect(() => {
    setSourceIndex(0);
  }, [name, domain]);

  if (domain && sourceIndex < sources.length) {
    return (
      <img
        src={sources[sourceIndex]}
        alt={name || 'Company'}
        title={name}
        onError={() => setSourceIndex(i => i + 1)}
        className={`${sizeClass} rounded-full object-cover bg-white border border-slate-200 flex-shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      title={name}
      className={`${sizeClass} rounded-full flex items-center justify-center font-bold flex-shrink-0 border border-slate-200 ${color.bg} ${color.text} ${className}`}
    >
      {initials}
    </div>
  );
}

export default CompanyLogo;